// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import Rails from "@rails/ujs"
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import '../css/application.scss'
Rails.start()
ActiveStorage.start()

require.context('../images', true)

import Swiper from 'swiper'
import TabSwitcher from './modules/sp/tab'
import SearchPanel from './modules/sp/search-panel'
import ModalMenu from './modules/sp/modal-menu'
import Accordion from './modules/sp/accordion'
import BlockAccordion from './modules/sp/block-accordion'
import Modal from './modules/sp/modal'
import SmoothScroll from './modules/sp/smooth-scroll'
import SmoothScrollPolyfill from 'smoothscroll-polyfill';
import AccessEffectScroll from './modules/sp/access-effect-scroll'
import 'lazysizes';

import 'controllers'
import '../components'

window.addEventListener('turbo:before-render', function() {
  location.reload();
})

window.addEventListener('turbo:load', function() {
  const IMAGE_SLIDER_COUNT = document.querySelectorAll('.js-image-slider-loop').length;
  new Swiper('.js-image-slider', {
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: '.swiper-pagination',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    slideCount: document.querySelectorAll('.js-image-slider-loop'),
    loop: IMAGE_SLIDER_COUNT > 1,
    watchOverflow: true
  })

  const sliderThumbnail = new Swiper('.js-campaign-thumbnail', {
    direction: 'vertical',
    slidesPerView: 4,
    spaceBetween: 12,
    watchOverflow: true,
  })
  new Swiper('.js-campaign-slider', {
    spaceBetween: 10,
    thumbs: {
      swiper: sliderThumbnail,
    },
  })

  const horizonalSliders = document.querySelectorAll('.js-horizonal-slider')
  horizonalSliders.forEach(slide => {
    const thumbnail = slide.nextSibling
    new Swiper(slide, {
      thumbs: {
        swiper:
          thumbnail && thumbnail.classList.contains('js-horizonal-thumbnail')
            ? new Swiper(thumbnail, {
                spaceBetween: 10,
                slidesPerView: 4,
              })
            : undefined,
      },
    })
  })

  const TAB_JS_ROOT_DOMS = document.querySelectorAll('.js-tab')
  if (TAB_JS_ROOT_DOMS.length > 0) {
    TAB_JS_ROOT_DOMS.forEach(dom => {
      new TabSwitcher(dom)
    })
  }

  const ACCORDION_JS_ROOT_DOM = document.querySelectorAll('.js-accordion')
  if (ACCORDION_JS_ROOT_DOM.length > 0) {
    ACCORDION_JS_ROOT_DOM.forEach(dom => {
      dom.querySelectorAll('.js-accordion-item').forEach(item => {
        new Accordion(item)
      })
    })
  }

  const BLOCK_ACCORDION_JS_ROOT_DOMS = document.querySelectorAll(
    '.js-block-accordion'
  )
  if (BLOCK_ACCORDION_JS_ROOT_DOMS.length > 0) {
    BLOCK_ACCORDION_JS_ROOT_DOMS.forEach(dom => {
      new BlockAccordion(dom)
    })
  }

  const SEARCH_PANEL_JS_ROOT_DOMS = document.querySelectorAll(
    '.js-search-panel-event'
  )
  if (SEARCH_PANEL_JS_ROOT_DOMS.length > 0) {
    SEARCH_PANEL_JS_ROOT_DOMS.forEach(dom => {
      new SearchPanel(dom)
    })
  }

  const MODAL_MENU_JS_ROOT_DOMS = document.querySelectorAll(
    '.js-modal-menu-event'
  )
  if (MODAL_MENU_JS_ROOT_DOMS.length > 0) {
    MODAL_MENU_JS_ROOT_DOMS.forEach(dom => {
      new ModalMenu(dom)
    })
  }

  const MODAL_JS_ROOT_DOMS = document.querySelectorAll('.js-modal')
  if (MODAL_JS_ROOT_DOMS.length > 0) {
    MODAL_JS_ROOT_DOMS.forEach(dom => {
      new Modal(dom)
    })
  }

  const SMOOTH_SCROLL_JS_ROOT_DOM = document.querySelectorAll('.js-smooth-scroll')
  if (SMOOTH_SCROLL_JS_ROOT_DOM.length > 0) {
    SmoothScrollPolyfill.polyfill()
    SMOOTH_SCROLL_JS_ROOT_DOM.forEach(dom => {
      new SmoothScroll(dom)
    })
  }

  const ACCESS_SCROLL_EFFECT_JS_ROOT_DOM = document.querySelector('.js-access-scroll-effect-target')
  if (ACCESS_SCROLL_EFFECT_JS_ROOT_DOM) {
    new AccessEffectScroll(ACCESS_SCROLL_EFFECT_JS_ROOT_DOM)
  }
})

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
